<script setup>
defineProps({
  blocks: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: '',
  },
})
</script>
<template>
  <div class="list-image-text row-400-20 p-bot-1 max">
    <!-- eslint-disable vue/no-v-html -->
    <h1
      v-if="title && ($route.path === '/azienda' || $route.path === '/partner')"
      class="heading-1 m-bot-1 intro-title"
      v-html="title"
    />
    <h2
      v-if="title && $route.path !== '/azienda' && $route.path !== '/partner'"
      class="heading-1 m-bot-1 intro-title"
      v-html="title"
    />
    <div class="blocks-container">
      <div v-for="(block, index) in blocks" :key="index" class="block">
        <div class="left">
          <DefaultPicture
            :image="{ custom: block.immagine.responsiveImage }"
            :lazy-load="true"
            :alt="block.titolo"
          />
        </div>
        <div class="right">
          <h2 class="heading-2-b title" v-html="block.titolo" />
          <div class="text-2" v-html="block.testo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListImageText',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
